import React, { Component } from 'react'
import css from './styles.scss'
import globalCss from '../../../../scss/global.scss'

import ModifiersEditor from '../ModifiersEditor'

export class RandomNumberEditor extends Component {
  roundingMethods = [
    <option value='' key='_EMPTY_OPTION_'>None</option>,
    <optgroup label='Integer' key='Integer'>
      <option value={5} key='Five'>Five</option>
      <option value={10} key='Ten'>Ten</option>
      <option value={50} key='Fifty'>Fifty</option>
      <option value={100} key='Hundred'>Hundred</option>
      <option value={500} key='Five Hundred'>Five Hundred</option>
      <option value={1000} key='Thousand'>Thousand</option>
      <option value={1000000} key='Million'>Million</option>
    </optgroup>
  ];

  constructor ({ variable }) {
    super()
    this.state = {
      min: variable.args[0] || variable.args[0] === 0 ? variable.args[0] : '',
      max: variable.args[1] || variable.args[1] === 0 ? variable.args[1] : '',
      minIsReference: variable.args[2] || false,
      maxIsReference: variable.args[3] || false,
      roundAmt: variable.args[4] || '',
      avoid: variable.args[5] || []
    }
    this.acceptableMacros = ['javascript', 'choiceFromReference', 'choiceFromAnonymous', 'randomNumber', 'number', 'getter', 'formula', 'round']
  }

  handleAddAvoid = () => {
    const { avoid } = this.state
    avoid.push('')
    this.setState({
      avoid: avoid
    })
  }

  removeAvoid (idx) {
    const avoid = this.state.avoid
    avoid.splice(idx, 1)
    this.setState({
      avoid: avoid
    })
  }

  updateAvoid = (value, idx) => {
    if (value.length && !isNaN(value)) {
      value = parseInt(value)
    }
    const updated = [...this.state.avoid]
    updated[idx] = value
    this.setState({
      avoid: updated
    })
  }

  handleUpdateRound = evt => {
    this.setState({
      roundAmt: evt.target.value
    })
  }

  handleUpdateMinimum = evt => {
    const value = evt.target.value
    if (isNaN(value)) {
      this.setState({
        min: value
      })
    } else {
      this.setState({
        min: parseInt(value, 10)
      })
    }
  }

  handleUpdateMaximum = evt => {
    const value = evt.target.value
    if (isNaN(value)) {
      this.setState({
        max: value
      })
    } else {
      this.setState({
        max: parseInt(value, 10)
      })
    }
  }

  handleMin = () => {
    this.setState({
      minIsReference: !this.state.minIsReference
    })
  }

  handleMax = () => {
    this.setState({
      maxIsReference: !this.state.maxIsReference
    })
  }

  componentWillReceiveProps (nextProps) {
    const { report, save, variableName } = this.props
    const { min, max, minIsReference, maxIsReference, roundAmt, avoid } = this.state
    if (nextProps.report === true && report === false) {
      save(variableName, [min, max, minIsReference, maxIsReference, roundAmt, avoid])
    }
  }

  componentDidUpdate (prevProps, prevState) {
    const { update } = this.props
    if (prevState !== this.state) {
      update()
    }
  }

  generateVariableList () {
    const { vars, variableName } = this.props
    const varList = []
    Object.keys(vars).forEach(varName => {
      if (variableName !== varName) {
        const varDeets = vars[varName]
        if (this.acceptableMacros.indexOf(varDeets.macro) > -1) {
          varList.push(
            <option value={varName} key={varName}>{varDeets.name}</option>
          )
        }
      }
    })
    return varList
  }

  render () {
    const { min, max, minIsReference, maxIsReference, avoid } = this.state
    const { primaryColor, modifiers, instance, instanceModifiers } = this.props
    let minNumInput = null
    let maxNumInput = null
    let avoidInput = null
    const varList = this.generateVariableList()
    const avoidList = avoid.map((numOrVar, i) => {
      const remove = (
        <button onClick={() => this.removeAvoid(i)} className={css.remove} style={{ color: primaryColor }}>
          <i className={globalCss.iconMinusCircled} />
        </button>
      )
      if (isNaN(numOrVar) || numOrVar === '_EMPTY_OPTION_') {
        return (
          <div key={i}>
            {remove}
            <div className={css.input}>
              <span className={css.switch}>
                <button onClick={() => this.updateAvoid('', i)} className={css.switchBtn}>
                  Use a Number
                </button>
              </span>
              <label>Number</label>
              <div className={css.backer}>
                <select value={numOrVar} onChange={evt => this.updateAvoid(evt.target.value, i)} className={css.select}>
                  <option value='_EMPTY_OPTION_'>Select a Variable</option>
                  {varList}
                </select>
              </div>
            </div>
          </div>
        )
      } else {
        return (
          <div key={i}>
            {remove}
            <div className={css.input}>
              <label>Number</label>
              <span className={css.switch}>
                <button onClick={() => this.updateAvoid('_EMPTY_OPTION_', i)} className={css.switchBtn}>Use a Variable</button>
              </span>
              <input type='number' value={numOrVar} onChange={evt => this.updateAvoid(evt.target.value, i)} className={css.option} />
            </div>
          </div>
        )
      }
    })
    if (minIsReference) {
      minNumInput = (
        <div className={css.input}>
          <label className={css.label}>
            Minimum
          </label>
          <span className={css.switch}>
            <button onClick={this.handleMin} className={css.switchBtn}>Use a Number</button>
          </span>
          <div className={css.backer}>
            <select className={css.select} value={min} onChange={this.handleUpdateMinimum}>
              <option value=''>Select a variable</option>
              {varList}
            </select>
          </div>

        </div>
      )
    } else {
      minNumInput = (
        <div className={css.input}>
          <label className={css.label}>
            Minimum
          </label>
          <span className={css.switch}>
            <button onClick={this.handleMin} className={css.switchBtn}>Use a Variable</button>
          </span>
          <input
            className={css.option}
            type='number'
            value={!min && min !== 0 ? '' : min}
            onChange={this.handleUpdateMinimum}
          />

        </div>
      )
    }
    if (maxIsReference) {
      maxNumInput = (
        <div className={css.input}>
          <label className={css.label}>
            Maximum
          </label>
          <span className={css.switch}>
            <button onClick={this.handleMax} className={css.switchBtn}>Use a Number</button>
          </span>
          <div className={css.backer}>
            <select className={css.select} value={max} onChange={this.handleUpdateMaximum}>
              <option value=''>Select a variable</option>
              {varList}
            </select>
          </div>
        </div>
      )
    } else {
      maxNumInput = (
        <div className={css.input}>
          <label className={css.label}>
            Maximum
          </label>
          <span className={css.switch}>
            <button onClick={this.handleMax} className={css.switchBtn}>Use a Variable</button>
          </span>
          <input
            className={css.option}
            type='number'
            value={!max && max !== 0 ? '' : max}
            onChange={this.handleUpdateMaximum}
          />
        </div>
      )
    }

    avoidInput = (
      <div className={css.avoidDiv}>
        <h3>{avoidList.length > 1 ? 'Avoid Numbers' : 'Avoid Number'}</h3>
        <ul>
          {avoidList}
        </ul>
        <button
          className={css.add}
          onClick={this.handleAddAvoid}
          type='button'
          style={{ background: primaryColor }}
        >
          <i className={globalCss.iconPlus} />
        </button>
      </div>
    )

    let instanceInput = null
    if (instance) {
      instanceInput = <ModifiersEditor instanceModifiers={instanceModifiers} isInstance />
    }

    return (
      <div className={css.margin}>
        <div className={css.minContainer}>
          {minNumInput}
        </div>
        <div className={css.maxContainer}>
          {maxNumInput}
          {avoidInput}
        </div>
        <ModifiersEditor modifiers={modifiers} />
        {instanceInput}
      </div>
    )
  }
}
export default RandomNumberEditor



// WEBPACK FOOTER //
// /app/js/components/EditVariable/RandomNumberEditor/index.js